const endpoints = {
	getClientCRM: '/clients/getClientCRM',
	getClientPreProjects: '/clients/getClientPreProjects',
	getClientContracts: '/clients/getClientContracts',
	getClientBudgets: '/clients/getClientBudgets',
	getClientReports: '/clients/getClientReports',
	getClientRequests: '/clients/getClientRequests'
}
export {endpoints}